import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add-blue",
  "use": "icon-add-blue-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-add-blue\"><defs><style>#icon-add-blue .cls-2{fill:none;stroke:#00ddff;stroke-miterlimit:10;stroke-width:4px;}</style></defs><g id=\"icon-add-blue_圖層_2\" data-name=\"圖層 2\"><g id=\"icon-add-blue_圖層_1-2\" data-name=\"圖層 1\"><g class=\"cls-1\"><line class=\"cls-2\" y1=\"8\" x2=\"16\" y2=\"8\" /><line class=\"cls-2\" x1=\"8\" y1=\"16\" x2=\"8\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol